import {
  type SelectionMode,
  type SelectionRange,
  SELECT_ALL_RANGE_ID,
} from '../state/types';

export function isSelectAll(range: SelectionRange, mode: SelectionMode): boolean {
  return mode === 'row' && range.id === SELECT_ALL_RANGE_ID;
}
